module.exports = __webpack_public_path__ + "img/moneys-disabled.3d1835b8.svg";